import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois';
import { getInquiries } from './inquiry.builder';
import { API_ROUTES } from '../../../utility/api.routes';
import { toast } from 'react-toastify';
import { ROUTES_PATH } from '../../../utility/constants';

export const getFollowupHistory = createAsyncThunk(
  "followup/getFollowupHistory",
  async (inquiryId) => {
    try {
      // i am setting this to check async call....
      const url = API_ROUTES.INQUIRY.GET_INQUIRY_FOLLOWUP(inquiryId)
      const response = await apiClient.get(url)  
      return response?.data?.result
    } catch (error) {
      console.error("builder function error:", error);
      throw error;
    }
  }
);

export const createFollowup = createAsyncThunk(
  "followup/createFollowup",
  async ({navigate, ...data}, {dispatch}) => {
    try {
      const url = API_ROUTES.INQUIRY.POST_INQUIRY_FOLLOWUP
      const response = await apiClient.post(url,data)  
      if(response?.status){
        toast.success(response.data.message, {
          className: 'custom-toast-success',
          progressStyle: { background: '#ffffff' },
        })
        dispatch(getInquiries({}))
        navigate(ROUTES_PATH.INQUIRY)
      }
      // dispatch(getFollowup())
    } catch (error) {
      toast.error(error.response.data.message,{
        className: 'custom-toast-error',
        progressStyle: { background: '#C53C43' },
      })
      console.error("builder function error:", error);
      throw error;
    }
  }
);

// export const editFollowup = createAsyncThunk(
//   "followup/editFollowup",
//   async (data , {dispatch}) => {
//     try {
//       const url = API_ROUTES.INQUIRY.TELEPHONIC.PUT_INQUIRY_FOLLOWUP
//       await apiClient.put(url,data)  
//       dispatch(getInquiries())
//     } catch (error) {
//       console.error("builder function error:", error);
//       throw error;
//     }
//   }
// );
